import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { FileText, ArrowRight, X } from 'lucide-react'
import api from '../api/client'
import { useAuth } from '../auth'

// PRD 06-08 (#7): nova versão de documento obrigatório → aviso ao entrar; acesso segue
// liberado, mas operações críticas (saque/cadastros) ficam bloqueadas até o aceite.
export default function AvisoTermosPendentes() {
  const { user, licenciado } = useAuth()
  const nav = useNavigate()
  const [pend, setPend] = useState(null)
  const [aberto, setAberto] = useState(true)

  useEffect(() => {
    if (user?.perfil !== 'licenciado' || !licenciado) return
    api.get('/termos/pendentes').then((r) => {
      if ((r.data?.obrigatorios_pendentes || 0) > 0) setPend(r.data)
    }).catch(() => {})
  }, [user, licenciado])

  if (!pend || !aberto) return null
  const docs = (pend.pendentes || []).filter((d) => d.obrigatorio)

  return (
    <div className="fixed inset-0 z-[65] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        <div className="h-1.5" style={{ background: 'linear-gradient(90deg, #ffcc00 0%, #ff6c00 100%)' }} />
        <div className="p-6">
          <div className="flex items-start gap-3">
            <div className="w-11 h-11 rounded-xl bg-accent-50 border border-accent-200 flex items-center justify-center flex-shrink-0">
              <FileText className="text-accent-500" size={22} />
            </div>
            <div className="flex-1">
              <h3 className="font-heading font-extrabold text-graphite text-lg">Atualização de Documentação</h3>
              <p className="text-sm text-gray-600 mt-1">
                {docs.length === 1
                  ? <>Existe uma nova versão de <b>{docs[0].nome}</b> disponível.</>
                  : <>Existem <b>{docs.length} documentos</b> aguardando o seu aceite.</>}
                {' '}É necessário visualizar e aceitar para continuar utilizando todos os recursos da plataforma.
              </p>
            </div>
            <button onClick={() => setAberto(false)} className="text-neutral-400 hover:text-neutral-600"><X size={18} /></button>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 mt-5">
            <button onClick={() => { setAberto(false); nav('/meus-documentos') }}
              className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl text-white font-bold py-3 hover:brightness-105 transition"
              style={{ background: 'linear-gradient(135deg, #ffcc00, #ff6c00)' }}>
              Visualizar Documento <ArrowRight size={15} />
            </button>
            <button onClick={() => setAberto(false)}
              className="flex-1 inline-flex items-center justify-center rounded-xl border border-neutral-200 text-graphite font-semibold py-3 hover:bg-neutral-50 transition">
              Depois
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
